import clsx from 'clsx'

import FansiMark from '@/atoms/FansiMark'
import FansiKind from '@/ts/enums/global/FansiKind'

const { FansiVideo } = FansiKind

function Heading({
  title,
  description,
}: {
  title: string
  description: string
}) {
  return (
    <div className="flex flex-col flex-shrink-0 space-y-4 lg:max-w-md xl:max-w-xl 2xl:max-w-2xl">
      <h1 className="text-3xl font-medium md:text-4xl 2xl:text-5xl">{title}</h1>
      <FansiMark kind={FansiVideo} />
      <h2 className={clsx('text-sm leading-[22px] md:text-base')}>
        {description}
      </h2>
    </div>
  )
}

export default Heading
